import { Lock, Key, Shield } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { AesEncrypt } from './AesEncrypt';
import { SecretGenerator } from './SecretGenerator';
import { PasswordStrength } from './PasswordStrength';

export const securityTools: Tool[] = [
  {
    id: 'aes-encrypt',
    name: 'AES-256 encrypt',
    category: 'security',
    description: 'Authenticated encryption with PBKDF2 key derivation.',
    keywords: ['encrypt', 'decrypt', 'aes', 'security', 'cipher'],
    icon: Lock,
    component: AesEncrypt,
    inBrowser: true,
  },
  {
    id: 'secret-generator',
    name: 'Secret generator',
    category: 'security',
    description: 'Cryptographic secrets in hex, base64, base64url, base58.',
    keywords: ['secret', 'token', 'api', 'key', 'random'],
    icon: Key,
    component: SecretGenerator,
    inBrowser: true,
  },
  {
    id: 'password-strength',
    name: 'Password strength',
    category: 'security',
    description: 'Entropy estimate, common-pattern checks, crack-time projection.',
    keywords: ['password', 'strength', 'entropy', 'crack', 'check'],
    icon: Shield,
    component: PasswordStrength,
    inBrowser: true,
  },
];
